/* Progressive enhancement: no navigation interception or cart state duplication. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  function resetMotion() {
    observer?.disconnect();
    document.querySelectorAll('.kt-awaiting,.kt-revealed').forEach(el => el.classList.remove('kt-awaiting', 'kt-revealed'));
  }
  function reveal(root = document) {
    if (reduced.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    observer ??= new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting}) => {
        if (!isIntersecting) return;
        target.classList.remove('kt-awaiting');
        target.classList.add('kt-revealed');
        observer.unobserve(target);
      });
    }, {threshold: 0.02, rootMargin: '0px 0px 40px 0px'});
    root.querySelectorAll('[data-kt-animate="true"] .kt-reveal').forEach(el => {
      if (el.dataset.ktObserved || el.getBoundingClientRect().top < innerHeight) return;
      el.dataset.ktObserved = 'true';
      el.classList.add('kt-awaiting');
      observer.observe(el);
    });
  }
  function engravingValidity(field) {
    const limit = Number(field.dataset.wordLimit);
    const count = field.value.trim().split(/\s+/u).filter(Boolean).length;
    field.setCustomValidity(count > limit ? `Please use no more than ${limit} words for your engraving.` : '');
  }
  document.addEventListener('input', event => {
    if (event.target.matches('[data-word-limit]')) engravingValidity(event.target);
  });
  // The native product-form handler receives only valid form-associated properties.
  document.addEventListener('submit', event => {
    const fields = document.querySelectorAll('[data-word-limit]');
    for (const field of fields) {
      if (field.form !== event.target) continue;
      engravingValidity(field);
      if (!field.validity.valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const disclosure = field.closest('details');
        if (disclosure) disclosure.open = true;
        field.focus();
        field.reportValidity();
        break;
      }
    }
  }, true);
  document.addEventListener('invalid', event => {
    if (event.target.matches('[data-word-limit]')) {
      const disclosure = event.target.closest('details');
      if (disclosure) disclosure.open = true;
    }
  }, true);
  const init = () => reveal();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.kt-awaiting').forEach(el => observer?.unobserve(el)));
  document.addEventListener('shopify:block:select', resetMotion);
  reduced.addEventListener('change', resetMotion);
  window.addEventListener('pageshow', event => { if (event.persisted) resetMotion(); });
})();
